import React from 'react';
import { classifyStatusTier, TIER_ICON, TIER_CLASS } from './designHelpers';

// Drop-in replacement for the old `<span className={`status-badge ${value.toLowerCase()}`}>`
// pattern used across screening_status / fadv_status / bg_status / drug_status /
// physical_status / gcic_status. Renders an em-dash for blank/null, matching the old behavior
// (an empty status-badge span rendered as empty text before too).
//
// `tier` is an optional override ('pass'|'warn'|'fail'|'info'|'neutral') for pages whose status
// vocabulary isn't the pass/fail/pending/eligible/uploaded set classifyStatusTier knows about --
// e.g. Dashboard's client pipeline stage (Lead/Closed/Onboard/NRLV) has nothing to do with
// candidate screening, so guessing its tier from keywords would be wrong. Pass the page's own
// mapping explicitly instead of growing classifyStatusTier into an app-wide kitchen sink.
export default function StatusLabel({ value, tier: tierOverride, label }) {
  if (!value || value === '-') return <span style={{ color: 'var(--muted)' }}>—</span>;
  const tier = tierOverride || classifyStatusTier(value);
  const icon = TIER_ICON[tier];
  return (
    <span className={`mtn-label ${TIER_CLASS[tier]}`}>
      {icon && <span className="mtn-ic">{icon}</span>}
      {label ?? value}
    </span>
  );
}
